import { useEffect } from "react";
import ReactGA from "react-ga4";

/** Sends a single pageview to GA4 in production. */
export default function usePageTracking() {
  useEffect(() => {
    const id = process.env.REACT_APP_MEASUREMENT_ID;
    if (!id || window.location.hostname === "localhost") return;
    ReactGA.initialize(id);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
}
